import { DatePicker, DatePickerProps, IconButton } from 'material-ui';
import CloseIcon from 'material-ui/svg-icons/navigation/close';
import * as React from 'react';
import './../ViewStyles/DatePicker.css';

interface IFIADatePickerProps {
    onClear:()=>void
}

export default class FIADatePicker extends React.Component<DatePickerProps & IFIADatePickerProps> {

    public render() {
        const { onClear } = this.props;
        const props = this.getDatepickerProps();
        return (
            <div className="date-picker-container">
                <DatePicker
                    {...props}
                    underlineStyle={{borderColor:'black'}}
                    className="date-picker"
                    fullWidth={true}
                    floatingLabelText="Кастомная дата"
                />
                {this.props.value ?
                    <IconButton style={{ marginLeft: -42 }}>
                        <CloseIcon
                            onClick={onClear}
                        />
                    </IconButton>
                    :
                    null
                }
            </div>
        )
    }


    private getDatepickerProps(){
        let p: any = this.props;
        if (Object.isFrozen(this.props)) {
            p = Object['unfreeze'](p)
        }
        delete p['onClear']
        return p;
    }
} 


// WEBPACK FOOTER //
// ./src/app/abstract/Views/DatePicker.tsx